import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from 'src/routes';
import { useAuth } from './auth/AuthContext';

export const RoleBasedPrivateRoute = ({
  requiredRole,
  children,
}: {
  requiredRole: string;
  children: React.ReactNode;
}) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkRole = async () => {
      if (!user) {
        navigate(ROUTES.HOME, { replace: true, state: { from: location } });
        return;
      }

      // Get fresh token to ensure claims are up to date
      const token = await user.getIdTokenResult(true);

      if (token.claims.role !== requiredRole) {
        navigate(ROUTES.HOME, { replace: true });
      }
    };

    checkRole();
  }, [user, requiredRole, navigate, location]);

  // Don't render anything while checking role
  if (!user) {
    return null;
  }

  return <>{children}</>;
};
